import { LinkableEntityType } from '@api';
import { Anchor } from '@common';

type PersonAnchorPropsType = { person: LinkableEntityType };

export const PersonAnchor: React.FC<PersonAnchorPropsType> = ({ person }) => {
  return (
    <Anchor key={person.id} to={`/persons/$id`} params={{ id: person.id }}>
      {person.name}
    </Anchor>
  );
};
